export default {"src":"/_next/static/media/PATH.c5253001.svg","height":18,"width":18};